"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetAQuote() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="get-a-quote" ref={sectionRef} className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className={`grid lg:grid-cols-[60%_40%] gap-12 items-start transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="space-y-6">
            <h1 className="text-[48px] md:text-[56px] leading-[1.1] font-bold tracking-[-0.2px] text-foreground">Arrange Cover</h1>
            <p className="text-[18px] leading-[1.7] max-w-2xl !text-[hsl(210,9%,31%)]">Take the first step towards comprehensive tax fee protection. Complete the form and our team will contact you to discuss cover. Fee protection is only for clients and cannot be taken out as a standard alone service.<br /><br />Fees for this service are based on the size of the company or individuals tax affairs, as per the below:<div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:5kwtov" data-ast-start="1540" data-ast-end="1564"></div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:5kvgr0" data-ast-start="1564" data-ast-end="1609">Company Turnover Cost</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:5keysq" data-ast-start="1609" data-ast-end="1767" contenteditable="false" style={{}}>Up to £350k&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£175</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:5jrtc5" data-ast-start="1767" data-ast-end="1919" contenteditable="false" style={{}}>£350k – £1m&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; £210</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:5iqy12" data-ast-start="1919" data-ast-end="2082" contenteditable="false" style={{}}>£1m – £2m&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£245</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:56jktu" data-ast-start="2082" data-ast-end="2245" contenteditable="false" style={{}}>£2m – £3m&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£280</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:55ihd4" data-ast-start="2245" data-ast-end="2408" contenteditable="false" style={{}}>£3m – £4m&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£315</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:54hdwe" data-ast-start="2408" data-ast-end="2571" contenteditable="false" style={{}}>£4m – £6m&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£350</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:53t9l6" data-ast-start="2571" data-ast-end="2634" contenteditable="false" style={{}}>Over £6m / Audit clients Call for quote</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:53bypt" data-ast-start="2634" data-ast-end="2657" contenteditable="false" style={{}}>Personal Tax</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:frxaa0" data-ast-start="2657" data-ast-end="2754" contenteditable="false" style={{}}>Sole Trader or Partnership&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;£175</div><div data-ast-id="f:/src/pages/TaxFeeProtection/sections/GetAQuote.tsx|sig:faxkud" data-ast-start="2754" data-ast-end="2879" contenteditable="false" style={{}}>Personal tax Return&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; £125</div></p>
          </div>

          {}
          <FormProvider className="bg-surface border border-border rounded-[var(--radius-sm)] p-6 shadow-[0_6px_16px_rgba(0,0,0,0.06)]" formId="get_quote_taxfeeprotection" sectionName="get-a-quote" defaultValues={{
          full_name: "",
          email_address: "",
          phone_number: "",
          company_name: "",
          service_interest: "",
          additional_details: ""
        }} validationRules={{
          full_name: {
            required: true,
            minLength: 2,
            maxLength: 100
          },
          email_address: {
            required: true,
            pattern: "email"
          },
          phone_number: {
            required: true,
            minLength: 10
          },
          service_interest: {
            required: true
          }
        }} submitText="Send Message" successMessage="Thank you! We will be on contact with you shortly." errorMessage="Unable to process your request. Please try again.">
            <QuoteForm />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function QuoteForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-accent-light border border-accent rounded-[var(--radius-sm)]">
        <p className="text-foreground text-[16px] leading-[1.6] mb-4">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="w-full">
          Submit Another Request
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-5">
        <FormField control={control} name="full_name" rules={{
        required: "Full name is required",
        minLength: {
          value: 2,
          message: "Minimum 2 characters"
        },
        maxLength: {
          value: 100,
          message: "Maximum 100 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Doe" {...field} className="rounded-[var(--radius-sm)] focus-visible:ring-primary/30 transition-all duration-[var(--duration-medium)]" />
              </FormControl>
              <FormDescription>
                Enter the name of the primary contact.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email_address" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane@example.com" {...field} className="rounded-[var(--radius-sm)] focus-visible:ring-primary/30 transition-all duration-[var(--duration-medium)]" />
              </FormControl>
              <FormDescription>
                We'll reply to this address.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone_number" rules={{
        required: "Phone number is required",
        minLength: {
          value: 10,
          message: "Minimum 10 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+44 20 1234 5678" {...field} className="rounded-[var(--radius-sm)] focus-visible:ring-primary/30 transition-all duration-[var(--duration-medium)]" />
              </FormControl>
              <FormDescription>
                Include country code for international callers.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company_name" render={({
        field
      }) => <FormItem>
              <FormLabel>Company / Organisation</FormLabel>
              <FormControl>
                <Input placeholder="J Doe Ltd" {...field} className="rounded-[var(--radius-sm)] focus-visible:ring-primary/30 transition-all duration-[var(--duration-medium)]" />
              </FormControl>
              <FormDescription>
                Optional
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="service_interest" rules={{
        required: "Please select a service"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Service of Interest</FormLabel>
              <FormControl>
                <select {...field} className="flex h-9 w-full rounded-[var(--radius-sm)] border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-primary/30 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm">
                  <option value="">Select a service</option>
                  <option value="Tax Fee Protection">Tax Fee Protection</option>
                  <option value="Cloud Accounting">Cloud Accounting</option>
                  <option value="Tax Investigation Support">
                    Tax Investigation Support
                  </option>
                  <option value="Other">Other</option>
                </select>
              </FormControl>
              <FormDescription>
                Choose the service.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="additional_details" render={({
        field
      }) => <FormItem>
              <FormLabel>Additional Details</FormLabel>
              <FormControl>
                <Textarea placeholder="Provide any specific requirements or questions..." {...field} className="rounded-[var(--radius-sm)] focus-visible:ring-primary/30 transition-all duration-[var(--duration-medium)] min-h-24" />
              </FormControl>
              <FormDescription>
                Provide as many details as possible.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-[var(--radius-sm)]">
            <p className="text-red-800 text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full rounded-[var(--radius-full)] bg-primary text-foreground-primary hover:bg-primary-hover shadow-medium transition-all duration-[var(--duration-fast)]">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Submitting...
            </> : "Send Message"}
        </Button>
      </div>
    </Form>;
}